// ABOUTME: Toggle button group for pinning a column left or right.
// ABOUTME: Shared by GridcolumnSettings3 (column list) and ShGridHeader3 (context menu).

import { Box, IconButton, useTheme } from "@mui/material";
import AlignHorizontalLeftIcon from "@mui/icons-material/AlignHorizontalLeft";
import AlignHorizontalRightIcon from "@mui/icons-material/AlignHorizontalRight";
import { useTranslation } from "react-i18next";

import { tokens } from "../../../theme";
import Text from "../text/Text";

/**
 * PinToggleGroup
 *
 * Props:
 *   pinnedLeft  — boolean
 *   pinnedRight — boolean
 *   onPinLeft   — () => void
 *   onPinRight  — () => void
 */
const PinToggleGroup = ({ pinnedLeft, pinnedRight, onPinLeft, onPinRight }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                display:'flex',
                justifyContent:'space-between',
                alignItems:'center',
            }}
        >
            <Text>
                {t("pin")}
            </Text>
            <Box
                sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    height: 40,
                    borderRadius: 5,
                    px: 0.5,
                    background: theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                    boxShadow: theme.palette.mode === "dark" ? "none" : `0px 2px 4px ${colors.grey[200]}`,
                    border: theme.palette.mode === "dark" ? `1px solid ${colors.grey[500]}` : `1px solid ${colors.grey[100]}`,
                    overflow: "hidden",
                }}
            >
                <IconButton
                    size="small"
                    onClick={onPinLeft}
                    aria-label={t("pin_left")}
                    sx={{
                        width: 32,
                        height: 32,
                        borderRadius: 4,
                        background: pinnedLeft
                            ? (theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100])
                            : "transparent",
                    }}
                >
                    <AlignHorizontalLeftIcon
                        sx={{
                            fontSize: 16,
                            color: pinnedLeft
                                ? (theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400])
                                : colors.txt.secondary,
                        }}
                    />
                </IconButton>
                <IconButton
                    size="small"
                    onClick={onPinRight}
                    aria-label={t("pin_right")}
                    sx={{
                        width: 32,
                        height: 32,
                        borderRadius: 3,
                        background: pinnedRight
                            ? (theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100])
                            : "transparent",
                    }}
                >
                    <AlignHorizontalRightIcon
                        sx={{
                            fontSize: 16,
                            color: pinnedRight
                                ? (theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400])
                                : colors.txt.secondary,
                        }}
                    />
                </IconButton>
            </Box>
        </Box>
    );
};

export default PinToggleGroup;
